import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "../CSS/Sidebar.css";
import Header from "./Header";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Toaster, toast } from "react-hot-toast";
import { logout } from "../redux/actions/userActions";
import $ from "jquery";
import Cookies from "js-cookie";
import useCountDown from 'react-countdown-hook';
import { API_BASE_URL } from "../config/serverApiConfig";
import ReleaseVersionBanner from "./ReleaseVersionBanner/releaseVersionBanner";

function Sidebar(props: any) {
  const [onHover, setOnHover] = useState({
    miniBar: false,
    SideBar: false,
  });
  const initialTime = 10 * 1000; // initial time in milliseconds, defaults to 60000
  const interval = 1000; // interval to change remaining time amount, defaults to 1000

  const [timeLeft, { start, pause, resume, reset }] = useCountDown(initialTime, interval);

  const restart = React.useCallback(() => {
    // you can start existing timer with an arbitrary value
    // if new value is not passed timer will start with initial value
    const newTime = 20 * 1000;
    start(newTime);
  }, []);
  const LoginUser = JSON.parse(localStorage.getItem("LoginUser"));
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const LogNotify = () => toast.success("Log-Out!");
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);

  const [releaseVersionAlert, setReleaseVersionAlert] = useState(false);
  const [isLeadsClientsOpen, setIsLeadsClientsOpen] = useState(false);
  const [isManageMenuOpen, setIsManageMenuOpen] = useState(false);
  const [storedVersion, setStoredVersion] = useState(JSON.parse(localStorage.getItem('versionData')) || null)

  useEffect(() => {
    const checkReleaseVersion = async () => {
      let versionResponse = await fetch(API_BASE_URL + 'check-heroku-updates')
      let versionData = await versionResponse.json();

      if (storedVersion !== null && JSON.stringify(storedVersion) === JSON.stringify(versionData)) {
        console.log("Version Data Not Changed - ", storedVersion, versionData);
        setReleaseVersionAlert(false);
      } else {
        localStorage.setItem('versionData', JSON.stringify(versionData));
        console.log("Version Data Changed - ", storedVersion, versionData);
        setReleaseVersionAlert(true);
      }
    }

    checkReleaseVersion()
  }, [])



  const LogOut = async () => {
    await dispatch(logout());
    await Cookies.remove("token");
    await localStorage.removeItem("token");
    await localStorage.removeItem("archive");
    await localStorage.removeItem("embauch");
    await localStorage.removeItem("profile");
    await localStorage.removeItem("LoginUser");
    navigate("/");
    LogNotify();
  };
  let login = Cookies.get("token");
  let token = localStorage.getItem("token");

  useEffect(() => {
    if (token) {
      LogOut();
    }
    if (!login) {
      LogOut();
    }
  }, [login]);

  useEffect(() => {
    $(document).on("click", "li", function () {
      $(this).addClass("active").siblings().removeClass("active");
      $(this).removeClass("active");
    });
  });

  const OnClickColorChange = (name: any) => {
    if (name === "Download") {
      navigate("/downloadCenter");
    }
    if (name === "Leads") {
      navigate("/LeadsCenter");
    }
    if (name === "Center") {
      navigate("/JobAdsCenter");
    }
    if (name === "Com") {
      navigate("/commercialCenter");
    }
    if (name === "bill") {
      navigate("/billing-center");
    }
    if (name === "offer") {
      navigate("/offerCenter");
    }

  };

  return (
    <>
      <Toaster position="top-right" />
      {
        releaseVersionAlert ? <ReleaseVersionBanner versionAlert={setReleaseVersionAlert} message={"A New Version for Intermann CRM has been released. Please Click on the Button on Right to update your CRM!"} /> : null
      }

      <div className="tw-flex tw-space-x-2 tw-h-screen scrollbar-hide">
        {isSidebarOpen ? (
          <div className={`tw-bg-[#032339] tw-transition-all tw-duration-300 tw-w-1/5 tw-overflow-x-auto scrollbar-hide`}>
            <div className="tw-flex tw-items-center tw-justify-between tw-p-1">
              {LoginUser?.username === 'PJ Darche' ? <Link to="/ris-candidates" className="tw-flex tw-justify-center tw-my-2 tw-w-[100%]">
                <img alt="..."
                  src={require("../images/intermann-logo-sidebar.svg").default}
                  className=""
                />
              </Link> : <Link to="/dashboard" className="tw-flex tw-justify-center tw-my-2 tw-w-[100%]">
                <img alt="..."
                  src={require("../images/intermann-logo-sidebar.svg").default}
                  className=""
                />
              </Link>}

              <img alt="..."
                src={require("../images/close.png")}
                className="tw-w-8 tw-cursor-pointer"
                onClick={() => {
                  setIsSidebarOpen(false);
                  setOnHover({ ...onHover, miniBar: false });
                }}
              />
            </div>

            {
              LoginUser?.username === 'PJ Darche' ? (
                <ul className="tw-flex tw-flex-col">
                  <li>
                    <Link
                      to="/ris-candidates"
                      className="sideBarBackG collapsed tw-flex tw-items-center tw-w-full tw-px-4 tw-py-2 tw-space-x-3"
                      type="button"
                    >
                      <img alt="..."
                        src={
                          require("../images/employeeicon.svg").default
                        }
                      />

                      <span className="tw-text-white hover:tw-text-[#FE8700] hover:tw-font-semibold">
                        Candidates
                      </span>
                    </Link>
                  </li>

                  <li
                    className="tw-border-t-[1px]"
                    onClick={(e) => LogOut()}
                  >
                    <Link to="/" className="sideBarBackG collapsed tw-flex tw-items-center tw-w-full tw-px-4 tw-py-2 tw-space-x-4" aria-current="page">
                      <img alt="..."
                        className="logoutImage"
                        src={require("../images/logout.svg").default}
                      />
                      <span className="tw-text-white hover:tw-text-[#FE8700] hover:tw-font-semibold">
                        Sign Out
                      </span>
                    </Link>
                  </li>
                </ul>
              ) : <ul className="tw-flex tw-flex-col">
                <li>
                  <Link
                    to="/dashboard"
                    className="tw-flex tw-items-center tw-w-full tw-px-4 tw-py-2 tw-border-t-[1px] tw-space-x-4 tw-bg-[#FFF7EE]"
                    aria-current="page"
                  >
                    <img alt="..." src={require("../images/Shape.svg").default} />
                    <span className="tw-text-[#FE8700] tw-flex-grow hover:tw-font-semibold">Resume</span>
                  </Link>
                </li>

                <li>
                  <Link
                    to="/candidates"
                    className="sideBarBackG collapsed tw-flex tw-items-center tw-w-full tw-px-4 tw-py-2 tw-space-x-3"
                    type="button"
                  >
                    <img alt="..."
                      src={
                        require("../images/employeeicon.svg").default
                      }
                    />

                    <span className="tw-text-white hover:tw-text-[#FE8700] hover:tw-font-semibold">
                      Candidates
                    </span>
                  </Link>
                </li>

                <li>
                  <button
                    className="sideBarBackG tw-relative collapsed tw-flex tw-items-center tw-w-full tw-px-4 tw-py-2 tw-space-x-3"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapseTwo"
                    aria-expanded="false"
                    aria-controls="#flush-collapseTwo"
                    onClick={() => setIsLeadsClientsOpen(!isLeadsClientsOpen)}
                  >
                    <img
                      alt="..."
                      src={require("../images/CombinedShape.svg").default}
                    />

                    <span className="tw-text-white hover:tw-text-[#FE8700] hover:tw-font-semibold">
                      Leads/Clients
                    </span>

                    <img
                      alt="..."
                      className={`tw-right-[20px] tw-absolute tw-flex-grow tw-w-4 tw-h-2 ${isLeadsClientsOpen ? "tw-transform tw-rotate-180" : ""}`}
                      src={require("../images/downArrow.svg").default}
                    />
                  </button>

                  <div
                    id="flush-collapseTwo"
                    className="accordion-collapse collapse"
                    aria-labelledby="flush-headingTwo"
                    data-bs-parent="#accordionFlushExample"
                  >
                    <ul
                      className="tw-flex tw-flex-col tw-space-y-2 tw-bg-[#032339]"
                    >
                      <li
                        className={
                          window.location.href.includes("clientTodo")
                            ? "sideBarBackGactive"
                            : "sideBarBackG"
                        }
                      >
                        <Link
                          to="/clientTodo"
                          className="tw-flex nav-link link-dark fontStylingBar tw-py-1 tw-space-x-4 tw-px-5"
                        >
                          <img alt="..."
                            className={
                              window.location.href.includes(
                                "clientTodo"
                              )
                                ? "FilterMinibar"
                                : ""
                            }
                            src={
                              require("../images/list-text.svg").default
                            }
                          />
                          <span>To Do</span>
                        </Link>
                      </li>

                      <li
                        className={
                          window.location.href.includes("clientProgress")
                            ? "sideBarBackGactive"
                            : "sideBarBackG"
                        }
                      >
                        <Link
                          to="/clientProgress"
                          className="tw-flex nav-link link-dark fontStylingBar tw-py-1 tw-space-x-4 tw-px-5"
                        >
                          <img alt="..."
                            className={
                              window.location.href.includes(
                                "clientProgress"
                              )
                                ? "FilterMinibar"
                                : ""
                            }
                            src={
                              require("../images/analytics.svg").default
                            }
                          />
                          <span>
                            Ongoing Research
                          </span>
                        </Link>
                      </li>

                      <li
                        className={
                          window.location.href.includes("clientContract")
                            ? "sideBarBackGactive"
                            : "sideBarBackG"
                        }
                      >
                        <Link
                          to="/clientContract"
                          className="tw-flex nav-link link-dark fontStylingBar tw-space-x-4 tw-px-5 tw-py-1"
                        >
                          <img alt="..."
                            className={
                              window.location.href.includes(
                                "clientContract"
                              )
                                ? "FilterMinibar"
                                : ""
                            }
                            src={
                              require("../images/contractList.svg")
                                .default
                            }
                          />
                          <span>
                            In-Progress
                          </span>
                        </Link>
                      </li>

                      <li
                        className={
                          window.location.href.includes("archived")
                            ? "sideBarBackGactive"
                            : "sideBarBackG"
                        }
                      >
                        <Link
                          to="/archived"
                          className="tw-flex nav-link link-dark fontStylingBar tw-py-1 tw-space-x-4 tw-px-5"
                        >

                          <img alt="..."
                            className={
                              window.location.href.includes("archived")
                                ? "FilterMinibar"
                                : ""
                            }
                            src={
                              require("../images/archivedList.svg")
                                .default
                            }
                          />
                          <span>
                            Archived
                          </span>
                        </Link>
                      </li>
                    </ul>
                  </div>
                </li>

                <li>
                  <button
                    className="sideBarBackG collapsed tw-relative tw-flex tw-items-center tw-w-full tw-px-4 tw-py-2 tw-space-x-3"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapseOne"
                    aria-expanded="false"
                    aria-controls="flush-collapseOne"
                    onClick={() => setIsManageMenuOpen(!isManageMenuOpen)}
                  >
                    <img alt="..."
                      src={require("../images/settings.svg").default}
                    />

                    <span className="tw-text-white hover:tw-text-[#FE8700] hover:tw-font-semibold">
                      Manage
                    </span>

                    <img
                      alt="..."
                      className={`tw-right-[20px] tw-absolute tw-flex-grow tw-w-4 tw-h-2 ${isManageMenuOpen ? "tw-transform tw-rotate-180" : ""}`}
                      src={require("../images/downArrow.svg").default}
                    />
                  </button>

                  <div
                    id="flush-collapseOne"
                    className="accordion-collapse collapse"
                    aria-labelledby="flush-headingOne"
                    data-bs-parent="#accordionFlushExample"
                  >
                    <ul className="tw-flex tw-flex-col tw-space-y-2 tw-bg-[#032339]">
                      <li
                        className={
                          window.location.href.includes("addNewSector")
                            ? "sideBarBackGactive"
                            : "sideBarBackG"
                        }
                      >
                        <Link
                          to="/addNewSector"
                          className="tw-flex nav-link link-dark fontStylingBar tw-py-1 tw-space-x-4 tw-px-5"
                          aria-current="page"
                        >
                          <img alt="..."
                            className={
                              window.location.href.includes(
                                "addNewSector"
                              )
                                ? "FilterMinibar"
                                : ""
                            }
                            src={
                              require("../images/addsector.svg").default
                            }
                          />
                          <span>
                            Add New Sector
                          </span>
                        </Link>
                      </li>
                      <li
                        className={
                          window.location.href.includes("userList")
                            ? "sideBarBackGactive"
                            : "sideBarBackG"
                        }
                        onClick={(e) => OnClickColorChange("User List")}
                      >
                        <Link
                          to="/userList"
                          className="tw-flex nav-link link-dark fontStylingBar tw-py-1 tw-space-x-4 tw-px-5"
                          aria-current="page"
                        >
                          <img alt="..."
                            className={
                              window.location.href.includes("userList")
                                ? "FilterMinibar"
                                : ""
                            }
                            src={
                              require("../images/adduser.svg").default
                            }
                          />
                          <span>
                            User List
                          </span>
                        </Link>
                      </li>
                    </ul>
                  </div>
                </li>

                <li>
                  <Link
                    to="/downloadCenter"
                    className="sideBarBackG collapsed tw-flex tw-items-center tw-w-full tw-px-4 tw-py-2 tw-space-x-4"
                    aria-current="page"
                  >
                    <img alt="..."
                      src={require("../images/telecharger.svg").default}
                    />
                    <span className="tw-text-white hover:tw-text-[#FE8700] hover:tw-font-semibold">
                      Download Center
                    </span>
                  </Link>
                </li>

                <li>
                  <Link
                    to="/LeadsCenter"
                    className="sideBarBackG collapsed tw-flex tw-items-center tw-w-full tw-px-4 tw-py-2 tw-space-x-4"
                    aria-current="page"
                  >
                    <img alt="..."
                      className={
                        window.location.href.includes("LeadsCenter")
                          ? "FilterMinibar logoutImage"
                          : "logoutImage"
                      }
                      src={require("../images/Leads.svg").default}
                    />
                    <span className="tw-text-white hover:tw-text-[#FE8700] hover:tw-font-semibold">
                      Leads Center
                    </span>
                  </Link>
                </li>

                <li>
                  <Link
                    to="/JobAdsCenter"
                    className="sideBarBackG collapsed tw-flex tw-items-center tw-w-full tw-px-4 tw-py-2 tw-space-x-4"
                    aria-current="page"
                  >
                    <img alt="..."
                      className={
                        window.location.href.includes("JobAdsCenter")
                          ? "FilterMinibar logoutImage"
                          : "logoutImage"
                      }
                      src={require("../images/CombinedShape.svg").default}
                    />
                    <span className="tw-text-white hover:tw-text-[#FE8700] hover:tw-font-semibold">
                      Job Ads Center
                    </span>
                  </Link>
                </li>

                <li>
                  <Link
                    to="/commercialCenter"
                    className="sideBarBackG collapsed tw-flex tw-items-center tw-w-full tw-px-4 tw-py-2 tw-space-x-4"
                    aria-current="page"
                  >
                    <img alt="..."
                      className={
                        window.location.href.includes("commercialCenter")
                          ? "FilterMinibar logoutImage"
                          : "logoutImage"
                      }
                      src={require("../images/comIcon.svg").default}
                    />
                    <span className="tw-text-white hover:tw-text-[#FE8700] hover:tw-font-semibold">
                      Commercial Center
                    </span>
                  </Link>
                </li>

                <li>
                  <a
                    href="https://docs.google.com/spreadsheets/d/1H5CClpD-iddzYeoUg6OtoXgJCPJQDymUsNtGMNh9XGs/edit#gid=0"
                    target="_blank"
                    className="sideBarBackG collapsed tw-flex tw-items-center tw-w-full tw-px-4 tw-py-2 tw-space-x-4"
                    aria-current="page"
                  >
                    <img alt="..."
                      className={
                        window.location.href.includes("kine-center")
                          ? "FilterMinibar logoutImage"
                          : "logoutImage"
                      }
                      src={require("../images/kine-center.svg").default}
                    />
                    <span className="tw-text-white hover:tw-text-[#FE8700] hover:tw-font-semibold">
                      Kiné Center
                    </span>
                  </a>
                </li>

                {LoginUser?.username === "Test" ? (
                  <li>
                    <Link
                      to="/billing-center"
                      className="sideBarBackG collapsed tw-flex tw-items-center tw-w-full tw-px-4 tw-py-2 tw-space-x-4"
                      aria-current="page"
                    >
                      <img alt="..."
                        width={"24px"}
                        src={require("../images/billingCenter.svg").default}
                        className={`${window.location.href.includes("billing")
                          ? "FilterMinibar"
                          : ""
                          }`}
                      />
                      <span className="tw-text-white hover:tw-text-[#FE8700] hover:tw-font-semibold">
                        Billing Center
                      </span>
                    </Link>
                  </li>
                ) : null}

                <li>
                  <Link
                    to="/offerCenter"
                    className="sideBarBackG collapsed tw-flex tw-items-center tw-w-full tw-px-4 tw-py-2 tw-space-x-4"
                    aria-current="page"
                  >
                    <img alt="..."
                      className={
                        window.location.href.includes("offerCenter")
                          ? "FilterMinibar logoutImage"
                          : "logoutImage"
                      }
                      src={require("../images/discount.svg").default}
                    />
                    <span className="tw-text-white hover:tw-text-[#FE8700] hover:tw-font-semibold">
                      Offer Center
                    </span>
                  </Link>
                </li>

                <li>
                  <Link
                    to="/document-generator"
                    className="sideBarBackG collapsed tw-flex tw-items-center tw-w-full tw-px-4 tw-py-2 tw-space-x-4"
                    aria-current="page"
                  >
                    <img alt="..."
                      className={
                        window.location.href.includes("document-generator")
                          ? "FilterMinibar logoutImage"
                          : "logoutImage"
                      }
                      src={require("../images/doc-generator.svg").default}
                    />
                    <span className="tw-text-white hover:tw-text-[#FE8700] hover:tw-font-semibold">
                      Document Generator
                    </span>
                  </Link>
                </li>

                <li>
                  <Link
                    to="/ris-candidates"
                    className="sideBarBackG collapsed tw-flex tw-items-center tw-w-full tw-px-4 tw-py-2 tw-space-x-3"
                    type="button"
                  >
                    <img alt="..."
                      src={
                        require("../images/employeeicon.svg").default
                      }
                    />

                    <span className="tw-text-white hover:tw-text-[#FE8700] hover:tw-font-semibold">
                      INTERMANN x RIS
                    </span>
                  </Link>
                </li>

                <li
                  className="tw-border-t-[1px]"
                  onClick={(e) => LogOut()}
                >
                  <Link to="/" className="sideBarBackG collapsed tw-flex tw-items-center tw-w-full tw-px-4 tw-py-2 tw-space-x-4" aria-current="page">
                    <img alt="..."
                      className="logoutImage"
                      src={require("../images/logout.svg").default}
                    />
                    <span className="tw-text-white hover:tw-text-[#FE8700] hover:tw-font-semibold">
                      Sign Out
                    </span>
                  </Link>
                </li>
              </ul>
            }
          </div>
        ) : (
          <div className={`sideBarBackG tw-bg-[#032339] tw-transition-all tw-duration-300 tw-overflow-x-auto scrollbar-hide`}>
            {onHover.miniBar ? (
              <div
                className="tw-cursor-pointer tw-py-2 tw-border-b-[1px] tw-flex tw-justify-center"
                onClick={() => setIsSidebarOpen(true)}
                onMouseLeave={() =>
                  setOnHover({ ...onHover, miniBar: false })
                }
              >
                <img alt="..."
                  src={require("../images/menu.png")}
                  className="tw-w-12 tw-h-10"
                />
              </div>
            ) : (
              <div
                className="tw-border-b-[1px] tw-py-2 tw-cursor-pointer tw-flex tw-justify-center"
                onMouseEnter={() => setOnHover({ ...onHover, miniBar: true })}
              >
                <img alt="..."
                  src={require("../images/logo-header.png")}
                  className="tw-w-12 tw-h-10"
                />
              </div>
            )}

            {
              LoginUser?.username === 'PJ Darche' ? <ul className="tw-flex tw-flex-col tw-space-y-4 tw-h-full">
                <li
                  className=" d-flex mt-1 align-items-center justify-content-center"
                  data-bs-toggle="tooltip"
                  data-bs-placement="right"
                  title="Candidats Section"
                >
                  {
                    window.location.href.includes("ris-candidates") ? (
                      <div className={"activeDiv tw-mx-2"}>
                        <img alt="..."
                          style={{ height: "25px", width: "35px" }}
                          className="FilterMinibar"
                          src={require("../images/employeeicon.svg").default}
                        />
                      </div>
                    ) : (
                      <div>
                        <Link to={"/ris-candidates"}>
                          <img alt="..."
                            style={{ height: "25px", width: "35px" }}
                            src={require("../images/employeeicon.svg").default}
                          />
                        </Link>
                      </div>
                    )}
                </li>
                <li className="tw-pt-2 mb-5 d-flex align-items-center justify-content-center tw-border-t-[1px]" data-bs-toggle="tooltip"
                  data-bs-placement="right"
                  title="Sign Out">
                  <div
                    onClick={() => LogOut()}
                    className={window.location.href.includes("/") ? "" : ""}
                  >
                    <Link to={"/"}>
                      <img alt="..."
                        style={{ height: "25px", width: "35px" }}
                        src={require("../images/logout.svg").default}
                      />
                    </Link>
                  </div>
                </li>
              </ul> : (
                <ul className="tw-flex tw-flex-col tw-space-y-4 tw-h-full">
                  <li className="tw-flex tw-justify-center tw-items-center tw-mt-5 tw-cursor-pointer">
                    <Link
                      to="/dashboard"
                      className="tw-flex tw-items-center tw-w-full tw-px-4"
                      aria-current="page"
                    >
                      <img alt="..."
                        className="tw-w-8"
                        src={require("../images/Shape.svg").default}
                      />
                    </Link>
                  </li>
                  <li
                    className=" d-flex align-items-center justify-content-center"
                    data-bs-toggle="tooltip"
                    data-bs-placement="right"
                    title="Client Section"
                  >
                    {window.location.href.includes("clientTodo") ||
                      window.location.href.includes("clientProgress") ||
                      window.location.href.includes("clientContract") ||
                      window.location.href.includes("archived") ? (
                      <div className={"activeDiv tw-mx-2"}>
                        <img alt="..."
                          style={{ height: "25px", width: "35px" }}
                          className="FilterMinibar"
                          src={require("../images/CombinedShape.svg").default}
                        />
                      </div>
                    ) : (
                      <div>
                        <Link to={"/clientTodo"}>
                          <img alt="..."
                            style={{ height: "25px", width: "35px" }}
                            src={require("../images/CombinedShape.svg").default}
                          />
                        </Link>
                      </div>
                    )}
                  </li>

                  <li
                    className=" d-flex align-items-center justify-content-center"
                    data-bs-toggle="tooltip"
                    data-bs-placement="right"
                    title="Candidats Section"
                  >
                    {
                      window.location.href.includes("candidates") ? (
                        <div className={"activeDiv tw-mx-2"}>
                          <img alt="..."
                            style={{ height: "25px", width: "35px" }}
                            className="FilterMinibar"
                            src={require("../images/employeeicon.svg").default}
                          />
                        </div>
                      ) : (
                        <div>
                          <Link to={"/candidates"}>
                            <img alt="..."
                              style={{ height: "25px", width: "35px" }}
                              src={require("../images/employeeicon.svg").default}
                            />
                          </Link>
                        </div>
                      )}
                  </li>

                  <li
                    className=" d-flex align-items-center justify-content-center"
                    data-bs-toggle="tooltip"
                    data-bs-placement="right"
                    title="Manage"
                  >
                    {window.location.href.includes("addNewSector") ||
                      window.location.href.includes("userList") ? (
                      <div className="activeDiv tw-mx-2">
                        <img alt="..."
                          style={{ height: "25px", width: "35px" }}
                          className="FilterMinibar"
                          src={require("../images/settings.svg").default}
                        />
                      </div>
                    ) : (
                      <div className="">
                        <Link to={"/addNewSector"}>
                          <img alt="..."
                            style={{ height: "25px", width: "35px" }}
                            src={require("../images/settings.svg").default}
                          />
                        </Link>
                      </div>
                    )}
                  </li>

                  <li
                    className=" d-flex align-items-center justify-content-center"
                    data-bs-toggle="tooltip"
                    data-bs-placement="right"
                    title="Download Center"
                  >
                    {window.location.href.includes("downloadCenter") ? (
                      <div className={"activeDiv tw-mx-2"}>
                        <img alt="..."
                          style={{ height: "25px", width: "35px" }}
                          className="FilterMinibar"
                          src={require("../images/telecharger.svg").default}
                        />
                      </div>
                    ) : (
                      <div className={""}>
                        <Link to={"/downloadCenter"}>
                          <img alt="..."
                            style={{ height: "25px", width: "35px" }}
                            src={require("../images/telecharger.svg").default}
                          />
                        </Link>
                      </div>
                    )}
                  </li>

                  <li
                    className=" d-flex align-items-center justify-content-center"
                    data-bs-toggle="tooltip"
                    data-bs-placement="right"
                    title="Leads Center"
                  >
                    {window.location.href.includes("LeadsCenter") ? (
                      <div
                        className={
                          window.location.href.includes("LeadsCenter")
                            ? "activeDiv tw-mx-2"
                            : ""
                        }
                      >
                        <img alt="..."
                          style={{ height: "25px", width: "35px" }}
                          className="FilterMinibar"
                          src={require("../images/Leads.svg").default}
                        />
                      </div>
                    ) : (
                      <div>
                        <Link to={"/LeadsCenter"}>
                          <img alt="..."
                            style={{ height: "25px", width: "35px" }}
                            src={require("../images/Leads.svg").default}
                          />
                        </Link>
                      </div>
                    )}
                  </li>

                  <li
                    className=" d-flex align-items-center justify-content-center"
                    data-bs-toggle="tooltip"
                    data-bs-placement="right"
                    title="Job Ads Center"
                  >
                    {window.location.href.includes("JobAdsCenter") ? (
                      <div className={"activeDiv tw-mx-2"}>
                        <img alt="..."
                          style={{ height: "25px", width: "35px" }}
                          className="FilterMinibar"
                          src={require("../images/CombinedShape.svg").default}
                        />
                      </div>
                    ) : (
                      <div className={""}>
                        <Link to={"/JobAdsCenter"}>
                          <img alt="..."
                            style={{ height: "25px", width: "35px" }}
                            src={require("../images/CombinedShape.svg").default}
                          />
                        </Link>
                      </div>
                    )}
                  </li>

                  <li
                    className=" d-flex align-items-center justify-content-center"
                    data-bs-toggle="tooltip"
                    data-bs-placement="right"
                    title="Commercial Center"
                  >
                    {window.location.href.includes("commercialCenter") ? (
                      <div className={"activeDiv tw-mx-2"}>
                        <img alt="..."
                          style={{ height: "25px", width: "35px" }}
                          className="FilterMinibar"
                          src={require("../images/comIcon.svg").default}
                        />
                      </div>
                    ) : (
                      <div className={""}>
                        <Link to={"/commercialCenter"}>
                          <img alt="..."
                            style={{ height: "25px", width: "35px" }}
                            className=""
                            src={require("../images/comIcon.svg").default}
                          />
                        </Link>
                      </div>
                    )}
                  </li>

                  <li
                    className=" d-flex align-items-center justify-content-center"
                    data-bs-toggle="tooltip"
                    data-bs-placement="right"
                    title="Kiné Center"
                  >
                    {window.location.href.includes("kine-center") ? (
                      <div className={"activeDiv tw-mx-2"}>
                        <img alt="..."
                          style={{ height: "25px", width: "35px" }}
                          className="FilterMinibar"
                          src={require("../images/kine-center.svg").default}
                        />
                      </div>
                    ) : (
                      <div className={""}>
                        <a href={"https://docs.google.com/spreadsheets/d/1H5CClpD-iddzYeoUg6OtoXgJCPJQDymUsNtGMNh9XGs/edit#gid=0"} target="_blank">
                          <img alt="..."
                            style={{ height: "25px", width: "35px" }}
                            className=""
                            src={require("../images/kine-center.svg").default}
                          />
                        </a>
                      </div>
                    )}
                  </li>

                  {LoginUser?.username === "Test" ? (
                    <li className=" d-flex align-items-center justify-content-center">
                      {window.location.href.includes("billing") ? (
                        <div className={"activeDiv tw-mx-2"}>
                          <img alt="..."
                            style={{ height: "26px", width: "26px" }}
                            className="FilterMinibar"
                            src={require("../images/billingCenter.svg").default}
                          />
                        </div>
                      ) : (
                        <div className={""}>
                          <Link to={"/billing-center"}>
                            <img alt="..."
                              style={{ height: "26px", width: "26px" }}
                              className=""
                              src={require("../images/billingCenter.svg").default}
                            />
                          </Link>
                        </div>
                      )}
                    </li>
                  ) : null}

                  <li>
                    <Link
                      to="/ris-candidates"
                      className="sideBarBackG collapsed tw-flex tw-items-center tw-w-full tw-px-4 tw-py-2 tw-space-x-3"
                      type="button"
                    >
                      <img alt="..."
                        src={
                          require("../images/employeeicon.svg").default
                        }
                      />
                    </Link>
                  </li>

                  <li
                    className=" d-flex align-items-center justify-content-center"
                    data-bs-toggle="tooltip"
                    data-bs-placement="right"
                    title="Commercial Center"
                  >
                    {window.location.href.includes("offerCenter") ? (
                      <div className={"activeDiv tw-mx-2"}>
                        <img alt="..."
                          style={{ height: "25px", width: "35px" }}
                          className="FilterMinibar"
                          src={require("../images/discount.svg").default}
                        />
                      </div>
                    ) : (
                      <div className={""}>
                        <Link to={"/offerCenter"}>
                          <img alt="..."
                            style={{ height: "25px", width: "35px" }}
                            className=""
                            src={require("../images/discount.svg").default}
                          />
                        </Link>
                      </div>
                    )}
                  </li>

                  <li className="tw-pt-2 mb-5 d-flex align-items-center justify-content-center tw-border-t-[1px]" data-bs-toggle="tooltip"
                    data-bs-placement="right"
                    title="Sign Out">
                    <div
                      onClick={() => LogOut()}
                      className={window.location.href.includes("/") ? "" : ""}
                    >
                      <Link to={"/"}>
                        <img alt="..."
                          style={{ height: "25px", width: "35px" }}
                          src={require("../images/logout.svg").default}
                        />
                      </Link>
                    </div>
                  </li>
                </ul>
              )
            }
          </div>
        )}

        <div
          className={
            `tw-transition-all tw-duration-300 tw-flex-grow tw-w-4/5 tw-px-2 tw-h-full tw-overflow-x-auto scrollbar-hide`
          }
        >
          {LoginUser?.username === 'PJ Darche' ? null : <Header onClickBarOpenClose={isSidebarOpen} />}
          <section >{props.children}</section>
        </div>
      </div>
    </>
  );
}
export default Sidebar;
